import React, { PureComponent } from 'react';

var classCallCheck = function classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var inherits = function inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var objectWithoutProperties = function objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var imageLoadedStyle = {
  opacity: '1'
};

var ImageFadeIn = function (_PureComponent) {
  inherits(ImageFadeIn, _PureComponent);

  function ImageFadeIn(props) {
    classCallCheck(this, ImageFadeIn);

    var _this = possibleConstructorReturn(this, (ImageFadeIn.__proto__ || Object.getPrototypeOf(ImageFadeIn)).call(this, props));

    _this.onImageLoad = function () {
      if (_this.componentMounted) {
        _this.setState({
          loaded: true
        });
      }
    };

    _this.state = {
      loaded: false
    };
    _this.componentMounted = false;
    return _this;
  }

  createClass(ImageFadeIn, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var imgSrc = this.props.src;

      if (imgSrc) {
        //load image in a new window.Image and update local state when image is loaded
        var img = new window.Image();
        img.src = imgSrc;
        img.onload = this.onImageLoad;
        this.componentMounted = true;
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.componentMounted = false;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          src = _props.src,
          loadAsBackgroundImage = _props.loadAsBackgroundImage,
          opacityTransition = _props.opacityTransition,
          style = _props.style,
          rest = objectWithoutProperties(_props, ['src', 'loadAsBackgroundImage', 'opacityTransition', 'style']); //add transition style

      var imageStyle = {
        opacity: '0'
      };
      imageStyle.transition = 'opacity ' + opacityTransition + 's ease 0s';
      return React.createElement(React.Fragment, null, !loadAsBackgroundImage && React.createElement('img', _extends({
        src: src
      }, rest, {
        style: this.state.loaded ? _extends({}, style, imageStyle, imageLoadedStyle) : imageStyle
      })), loadAsBackgroundImage && React.createElement('div', _extends({}, rest, {
        style: this.state.loaded ? _extends({
          backgroundImage: 'url(\'' + src + '\')'
        }, style, imageStyle, imageLoadedStyle) : imageStyle
      }), this.props.children));
    }
  }]);
  return ImageFadeIn;
}(PureComponent);

ImageFadeIn.defaultProps = {
  loadAsBackgroundImage: false,
  opacityTransition: .5
};
export default ImageFadeIn;